import { Component, input } from '@angular/core';
import { EngageCardCtaImgComponent } from '../engage-card-cta/components/engage-card-cta-img/engage-card-cta-img.component';
import { SourceTrackingTypes } from '@uc/web/shared/data-models';
import { NgOptimizedImage } from '@angular/common';
import { CdnPathPipe, ClearingService } from '@uc/utilities';
import { CallUniBtnComponent } from '@uc/web/shared/leads';

@Component({
	selector: 'uc-engage-card-cta-call-uni',
	templateUrl: './engage-card-cta-call-uni.component.html',
	imports: [
		CallUniBtnComponent,
		EngageCardCtaImgComponent,
		NgOptimizedImage,
		CdnPathPipe,
	],
})
export class EngageCardCtaCallUniComponent {
	uniId = input.required<number>();
	uniName = input.required<string>();
	phoneNumber = input.required<string>();
	sourceType = input.required<SourceTrackingTypes>();
	source = input.required<string>();
	cleSearchOrderPosition = input.required<number>();

	currentClearingYear = this._clearingSrv.getYear();

	readonly componentName = 'Call University CTA';

	constructor(private _clearingSrv: ClearingService) {}
}
